import { Button } from "@mui/material";
import { Link, useLocation } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useContext } from "react";
import { string } from "prop-types";
import { useTextDomainContext } from "@/app/providers";

interface BackButtonProps {
  link?: string;
}

export const BackButton = (props: BackButtonProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const location = useLocation();
  const { link = location.state?.parentPath || "" } = props;
  return (
    link && (
      <Button
        component={Link}
        to={link}
        startIcon={<ArrowBackIcon />}
        variant="outlined"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {gettext("Back")}
      </Button>
    )
  );
};

BackButton.propTypes = {
  link: string,
};
